import React from 'react';
import {
  Card,
  Skeleton,
  Stack,
  styled,
} from '@material-ui/core';

import { User } from '../../types';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { RootState } from '../../store';

import { actions } from '../../services/users';
import { ProfilePhoto } from '../../components/UserPhoto/UserPhoto';


const PhotosContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
});

const HEIGHT = 250;


interface Props {
  user: User;
}

const UserPhotos: React.FC<Props> = ({ user }) => {

  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.users);

  useEffect(() => {
    if (state.photosLoading || state.profilePhotos[ user.id ]) {
      return;
    }
    dispatch(actions.loadProfilePhotos(user.id));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.id]);

  const photos = state.profilePhotos[ user.id ] ? state.profilePhotos[ user.id ] : [];


  return (
    <Card sx={{ overflow: 'scroll', height: HEIGHT, marginBottom: 2, }} variant="outlined">

      {
        state.photosLoading ? (
          <Stack direction="row" spacing={1}>
            <Skeleton width={150} height={HEIGHT} variant="rectangular" />
            <Skeleton width={150} height={HEIGHT} variant="rectangular" />
            <Skeleton width={150} height={HEIGHT} variant="rectangular" />
            <Skeleton width={150} height={HEIGHT} variant="rectangular" />
          </Stack>
        ) : (
          <PhotosContainer>
            {photos.map(photo => (
              <ProfilePhoto
                key={photo.id}
                photo={photo}
                height={HEIGHT}
                showAddTime
                sx={{
                  marginRight: '1px',
                  ':last-child': {
                    marginRight: 0,
                  }
                }}
              />
            ))}
          </PhotosContainer>
        )
      }
    </Card>
  )
}

export default UserPhotos;